import { render, staticRenderFns } from "./EventTypeSelectModal.vue?vue&type=template&id=2a36bcee"
import script from "./EventTypeSelectModal.vue?vue&type=script&lang=ts"
export * from "./EventTypeSelectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a36bcee')) {
      api.createRecord('2a36bcee', component.options)
    } else {
      api.reload('2a36bcee', component.options)
    }
    module.hot.accept("./EventTypeSelectModal.vue?vue&type=template&id=2a36bcee", function () {
      api.rerender('2a36bcee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/EventTypeSelectModal.vue"
export default component.exports